import { useEffect, useState } from 'react'
import { me } from '../utils/authHelper'

const AuthGate: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [ready, setReady] = useState(false)

    useEffect(() => {
        const run = async () => {
            const ok = await me()
            if (!ok) {
                window.location.href = '/login'
                return
            }
            setReady(true)
        }

        run()
    }, [])

    if (!ready) return null
    return <>{children}</>
}

export default AuthGate